import { ROSTER_TOPIC_LIST, ROSTER_CSV_FORMATS, ROSTER_MOTHODS, CUSTOM_ROSETR_HEAD,
    FILE_UPLOAD_RESPONCE, ROSTER_MOTHODS_KEYS, CUSTOM_ROSTER_SELECTION_TYPE } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';
import * as JSZIP from 'jszip';
import { rosterAPI } from '@/providers/apis/roster/roster';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'roster-upload',
    components: {
        'popup-layout': () => import('@/components/cards/slide-popup-layout/slide-popup-layout.vue'),
        'error-popup': () => import('@/components/cards/error-popup/error-popup'),
    },
})

export default class RosterUpload extends Vue {

    // -------------------------------------------------------------------
    // Properties

    private fieldHead: any = [
        {
            key: 'file_name',
            label: 'File Name',
        },
        {
            key: 'invalid_rows',
            label: 'Invalid/Empty Rows',
        },
        {
            key: 'headers',
            label: 'Headers Fields',
        },
    ];

    private isShowMessage: boolean = false;

    private isUploadedSuccessfully: boolean = false;

    private fieldItems: any = [];

    private rosterFile: any = null;

    private rosterTypes: any = CUSTOM_ROSTER_SELECTION_TYPE;

    private activeRoster: any = ROSTER_TOPIC_LIST[1];

    private activeCSV: string = ROSTER_CSV_FORMATS;

    private selectedRosterMethod: string = ROSTER_MOTHODS_KEYS.oneRoster0;

    private rosterMethod: any = ROSTER_MOTHODS;

    private rosterKeys: any = ROSTER_MOTHODS_KEYS;

    private displayRosterTypeDropdown: boolean = false;

    private isLoading: boolean = false;

    private customRosterHead: any = CUSTOM_ROSETR_HEAD;

    private customRosterData: any = [];

    private fileUploadResponces: any = FILE_UPLOAD_RESPONCE;

    private isShowPullup: boolean = false;

    private isShowErrorPullup: boolean = false;

    private dataBind: any = {};

    private selectedData: any = {};

    private rowsArray: any = [];

    private tenantId: string = '';
    private userId: string = '';
    private perPage: number = 10;

    private totalRowCounts: number = 0;

    private limit: number = 10;

    private offset: number = 0;

    private currentPage: number = 1;

    private rosterTemplateType: string = ROSTER_MOTHODS_KEYS.oneRoster0;

    private selectedCustomType: any = CUSTOM_ROSTER_SELECTION_TYPE[0].identifier;

    private rosterOptions: any = [
        { text: ROSTER_MOTHODS.oneRoster0, value: ROSTER_MOTHODS_KEYS.oneRoster0 },
    ];

    public created() {
        const template = this.$access.getTenantSettingsLocal();
        this.rosterTemplateType = template && template.roster_format ?
        template.roster_format : ROSTER_MOTHODS_KEYS.oneRoster0;
        this.tenantId = this.$access.getTenantId();
        this.showRosterTypeByTenant();
        this.userId = this.$access.getUserId();
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        if (this.rosterTemplateType === ROSTER_MOTHODS_KEYS.custom) {
            this.getCustomRosterList(paging);
        }
        this.filterRosterType();
    }

    public showRosterTypeByTenant() {
        if (this.rosterTemplateType === ROSTER_MOTHODS_KEYS.custom) {
            this.rosterOptions = [{ text: ROSTER_MOTHODS.custom, value: ROSTER_MOTHODS_KEYS.custom }];
            this.selectedRosterMethod = ROSTER_MOTHODS_KEYS.custom;
        } else if (this.rosterTemplateType === ROSTER_MOTHODS_KEYS.oneRoster0) {
            this.rosterOptions = [{ text: ROSTER_MOTHODS.oneRoster0, value: ROSTER_MOTHODS_KEYS.oneRoster0 }];
            this.selectedRosterMethod = ROSTER_MOTHODS_KEYS.oneRoster0;
        } else if (this.rosterTemplateType === ROSTER_MOTHODS_KEYS.oneRoster1) {
            this.rosterOptions = [{ text: ROSTER_MOTHODS.oneRoster1, value: ROSTER_MOTHODS_KEYS.oneRoster1 }];
            this.selectedRosterMethod = ROSTER_MOTHODS_KEYS.oneRoster1;
        }
    }

    public onSelectRosterType(value: any) {
        this.selectedCustomType = value;
        this.customRosterData = [];
        this.totalRowCounts = 0;
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }

    public rosterChanges() {
        const inputValue = '';
    }

    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/users-rosters/roster-syncs');
    }

    private onFileSelect(event: any) {
        const fileDetails = event.target.files[0];
        this.rosterFile = { ...fileDetails };
        this.fieldItems = [];
        JSZIP.loadAsync(fileDetails).then((zipData) => {
            const fileList = zipData.files;
            Object.keys(fileList).forEach((file) => {
                if (!fileList[file].dir) {
                    const fileName = fileList[file].name.split('/').pop();
                    fileList[file].async('string').then((fileData) => {
                        this.readerFile(fileData, fileName);
                    });
                }
            });
        });
    }

    private onUploadData() {
        if (this.rosterFile) {
            this.isLoading = true;
            this.isShowMessage = false;
            if (this.selectedRosterMethod === ROSTER_MOTHODS_KEYS.oneRoster0) {
                this.rosterZeroAPI();
            } else if (this.selectedRosterMethod === ROSTER_MOTHODS_KEYS.oneRoster1) {
                this.rosterOneAPI();
            } else if (this.selectedRosterMethod === ROSTER_MOTHODS_KEYS.custom) {
                this.rosterCustomAPI();
            }
        }
    }

    private rosterZeroAPI() {
        rosterAPI.uploadRosterOldVersion(this.rosterFile).then((responce) => {
            this.rosterFile = null;
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = true;
        }).catch((error) => {
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = false;
        });
    }

    private rosterOneAPI() {
        rosterAPI.uploadRoster(this.rosterFile).then((responce) => {
            this.rosterFile = null;
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = true;
        }).catch((error) => {
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = false;
        });
    }

    private rosterCustomAPI() {
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        rosterAPI.uploadCustomRoster(this.rosterFile, this.userId, this.tenantId, this.selectedCustomType).
        then((responce) => {
            this.rosterFile = null;
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = true;
            this.getCustomRosterList(paging);
        }).catch((error) => {
            this.isLoading = false;
            this.isShowMessage = true;
            this.isUploadedSuccessfully = false;
            this.getCustomRosterList(paging);
        });
    }


    // ---------------------------------------------------------------------
    // Methods

    private readerFile(results: any, fileName: any) {
        const rows = results.split('\n');
        const headers = rows.shift();
        const headerColumns = headers.split(',');

        this.fieldItems.push({
            file_name: fileName,
            headers: headerColumns,
            invalid_rows: this.parseTotalCounts(rows, headerColumns),
        });

    }

    private parseTotalCounts(rows: any, headerColumns: any) {
        let count = 0;
        rows.forEach((row: any) => {
            if (row) {
                if (headerColumns.length !== row.split(',').length) {
                    count++;
                }
                return;
            }
            count++;

        });
        return count;
    }

    private viewRosterDetails(itemSelcted: any) {
        this.isShowPullup = true;
        this.dataBind.activeRoster = itemSelcted;
    }

    private showErrorLogs(itemSelcted: any) {
        this.isShowErrorPullup = true;
        this.selectedData = itemSelcted;
    }

    private getCustomRosterList(paging: any) {
        this.isLoading = true;
        const type = this.selectedCustomType === CUSTOM_ROSTER_SELECTION_TYPE[0].identifier ? 'roster' : 'hierarchy';
        rosterAPI.getCustomRosterList(this.tenantId, this.userId, paging , type).then((data: any) => {
            this.isLoading = false;
            this.customRosterData = data.list;
            this.totalRowCounts = data.totalCounts;
        });
    }

    private onSelectPage(pageNumber: number) {
        this.currentPage = pageNumber;
        const currentOffset = (pageNumber - 1) * this.perPage;
        const paging = {
            offset: currentOffset,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }

    private filterRosterType() {
        if (!sessionService.isAdminORSuperAdmin()) {
            this.rosterTypes = this.rosterTypes.filter((item: any) => item.identifier !== 'group_hierarchy');
        }
    }

    private refreshTable() {
        this.customRosterData = [];
        this.totalRowCounts = 0;
        this.currentPage = 1;
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }
}
